import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c(
        VContainer,
        [
          _c(
            VRow,
            [
              _c(
                VCol,
                { attrs: { cols: "12" } },
                [
                  _c(
                    VForm,
                    {
                      ref: "form",
                      staticClass: "form",
                      attrs: { "lazy-validation": "" },
                      model: {
                        value: _vm.valid,
                        callback: function ($$v) {
                          _vm.valid = $$v
                        },
                        expression: "valid",
                      },
                    },
                    [
                      _c(
                        VRow,
                        { attrs: { "no-gutters": "" } },
                        [
                          _c(
                            VCol,
                            { attrs: { cols: "12", md: "12" } },
                            [
                              _c(VTextField, {
                                attrs: {
                                  label: _vm.label.group_name,
                                  placeholder: _vm.label.group_name,
                                  dense: "",
                                  name: "form.group_name",
                                  outlined: "",
                                  rules: _vm.rules.name,
                                },
                                model: {
                                  value: _vm.form.group_name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "group_name", $$v)
                                  },
                                  expression: "form.group_name",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            { attrs: { cols: "12" } },
                            [
                              _c(VTextarea, {
                                attrs: {
                                  label: _vm.label.group_description,
                                  placeholder: _vm.label.group_description,
                                  dense: "",
                                  name: "form.group_description",
                                  outlined: "",
                                  rows: "2",
                                  rules: _vm.rules.description,
                                },
                                model: {
                                  value: _vm.form.group_description,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "group_description", $$v)
                                  },
                                  expression: "form.group_description",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VTabs,
        {
          attrs: { "center-active": "", "fixed-tabs": "" },
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        [
          _c(VTab, [_vm._v(" " + _vm._s(_vm.$t("frases.search")) + " ")]),
          _c(VTab, [
            _vm._v(" " + _vm._s(_vm.$t("frases.attributes_selection")) + " "),
          ]),
        ],
        1
      ),
      _c(
        VTabsItems,
        {
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        [
          _c(
            VTabItem,
            [
              _c(
                VRow,
                [
                  _c(
                    VCol,
                    { attrs: { cols: "12" } },
                    [
                      _c(VTextField, {
                        staticClass: "mt-2 mx-3 hidden-xs-only",
                        attrs: {
                          placeholder: "Buscar",
                          "prepend-inner-icon": "mdi-magnify",
                          "hide-details": "",
                          filled: "",
                          rounded: "",
                          dense: "",
                        },
                        on: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.sendToSearch($event)
                          },
                        },
                        model: {
                          value: _vm.q,
                          callback: function ($$v) {
                            _vm.q = $$v
                          },
                          expression: "q",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.encontrado.busqueda.length > 0
                    ? _c(
                        VCol,
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            VForm,
                            {
                              ref: "form",
                              attrs: { "lazy-validation": "" },
                              model: {
                                value: _vm.valid,
                                callback: function ($$v) {
                                  _vm.valid = $$v
                                },
                                expression: "valid",
                              },
                            },
                            [
                              _c(VDataTable, {
                                staticClass: "text-center table-inca",
                                attrs: {
                                  responsive: "",
                                  items: _vm.encontrado.busqueda,
                                  headers: _vm.headers,
                                  loading: _vm.isLoading,
                                  disabled: _vm.isLoading,
                                  "hide-default-footer": "",
                                  "items-per-page": _vm.pagination.search.limit,
                                  page: _vm.pagination.search.current,
                                },
                                on: {
                                  pagination: function ($event) {
                                    _vm.pagination.search.total =
                                      $event.itemsLength
                                  },
                                  "update:page": function ($event) {
                                    return _vm.$set(
                                      _vm.pagination.search,
                                      "current",
                                      $event
                                    )
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "header.actions",
                                      fn: function (ref) {
                                        var header = ref.header
                                        return [
                                          _c(
                                            VIcon,
                                            {
                                              attrs: { medium: "" },
                                              on: { click: _vm.addAllItem },
                                            },
                                            [_vm._v("mdi-plus-circle-outline ")]
                                          ),
                                        ]
                                      },
                                    },
                                    {
                                      key: "item.no_nulo",
                                      fn: function (ref) {
                                        var item = ref.item
                                        return [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                item.no_nulo === -1
                                                  ? "-"
                                                  : Math.round(item.no_nulo) +
                                                      "%"
                                              ) +
                                              " "
                                          ),
                                        ]
                                      },
                                    },
                                    {
                                      key: "item.actions",
                                      fn: function (ref) {
                                        var item = ref.item
                                        return [
                                          _c(VHover, {
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (ref) {
                                                    var hover = ref.hover
                                                    return [
                                                      _c(
                                                        VIcon,
                                                        {
                                                          staticClass: "mr-2",
                                                          attrs: {
                                                            medium: "",
                                                            color:
                                                              item.status &&
                                                              hover
                                                                ? "#F03063"
                                                                : item.status &&
                                                                  !hover
                                                                ? "#0021CF"
                                                                : !item.status &&
                                                                  !hover
                                                                ? "#4B4D53"
                                                                : "#0021CF",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.editItem(
                                                                item
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                item.status &&
                                                                  hover
                                                                  ? "mdi-minus-circle-outline"
                                                                  : item.status &&
                                                                    !hover
                                                                  ? "mdi-check-circle-outline"
                                                                  : !item.status &&
                                                                    !hover
                                                                  ? "mdi-plus-circle-outline"
                                                                  : "mdi-check-circle-outline"
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3342674844
                                ),
                              }),
                              _c("pagination-vue", {
                                attrs: { pagination: _vm.pagination.search },
                              }),
                            ],
                            1
                          ),
                          [
                            _c(
                              "div",
                              { staticClass: "text-left pb-2" },
                              [
                                _c(VPagination, {
                                  attrs: {
                                    length: Math.ceil(
                                      _vm.encontrado.found /
                                        _vm.encontrado.per_page
                                    ),
                                    circle: "",
                                    "total-visible": 7,
                                  },
                                  on: { input: _vm.next },
                                  model: {
                                    value: _vm.encontrado.page,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.encontrado, "page", $$v)
                                    },
                                    expression: "encontrado.page",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                        ],
                        2
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VTabItem,
            [
              _c(
                VRow,
                [
                  _c(
                    VCol,
                    [
                      _c(VDataTable, {
                        key: _vm.keyTable,
                        staticClass: "table-inca elevation-2",
                        attrs: {
                          items: _vm.attributesList,
                          headers: _vm.headers,
                          dense: "",
                          "hide-default-footer": true,
                          "group-by": "categoria",
                          "items-per-page": _vm.pagination.limit,
                          page: _vm.pagination.current,
                        },
                        on: {
                          pagination: function ($event) {
                            _vm.pagination.total = $event.itemsLength
                          },
                          "update:page": function ($event) {
                            return _vm.$set(_vm.pagination, "current", $event)
                          },
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "item.no_nulo",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      item.no_nulo === -1
                                        ? "-"
                                        : Math.round(item.no_nulo) + "%"
                                    ) +
                                    " "
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.actions",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _c(VHover, {
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var hover = ref.hover
                                          return [
                                            _c(
                                              VIcon,
                                              {
                                                staticClass: "mr-2",
                                                attrs: {
                                                  medium: "",
                                                  color: hover
                                                    ? "#F03063"
                                                    : "#0021CF",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.removeItem(item)
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      hover
                                                        ? "mdi-minus-circle-outline"
                                                        : "mdi-check-circle-outline"
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ]
                            },
                          },
                          {
                            key: "group.header",
                            fn: function (ref) {
                              var items = ref.items
                              var isOpen = ref.isOpen
                              var toggle = ref.toggle
                              var group = ref.group
                              return [
                                _c(
                                  "th",
                                  { attrs: { colspan: _vm.headers.length } },
                                  [
                                    _c(
                                      VCard,
                                      {
                                        attrs: {
                                          flat: "",
                                          color: "transparent",
                                        },
                                      },
                                      [
                                        _c(
                                          VCardActions,
                                          { staticClass: "mt-2" },
                                          [
                                            _c(
                                              VRow,
                                              { attrs: { dense: "" } },
                                              [
                                                _c(VCol, [
                                                  _c(
                                                    "div",
                                                    [
                                                      _c(
                                                        VIcon,
                                                        {
                                                          attrs: { left: "" },
                                                          on: { click: toggle },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              isOpen
                                                                ? "mdi-minus"
                                                                : "icon-add"
                                                            ) + " "
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            items[0].categoria
                                                          ) +
                                                          " "
                                                      ),
                                                      _c(
                                                        VChip,
                                                        {
                                                          staticClass: "ml-2",
                                                          attrs: { label: "" },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(items.length)
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("pagination-vue", {
                        attrs: { pagination: _vm.pagination },
                      }),
                      _c(
                        VCol,
                        {
                          staticClass: "text-right mt-2 mr-2",
                          attrs: { cols: "12" },
                        },
                        [
                          _c(
                            VBtn,
                            {
                              attrs: { color: "primary", type: "button" },
                              on: { click: _vm.onUpdate },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("botones.boton_update")) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }